import React from "react";
import { StyledHeaderStep, StyledHeaderStepContainer } from "./styled";
import { RightOutlined } from "@ant-design/icons";

const StepCustomHeader = ({ historyStep, items, current, setCurrent }) => {
  const handleSelectStep = (index) => {
    if (index <= historyStep) setCurrent(index);
  };
  return (
    <StyledHeaderStepContainer>
      {!items[current].final ? (
        <>
          {items
            .filter((item) => !item.final)
            .map((item, index) => (
              <StyledHeaderStep
                style={{
                  cursor: "pointer",
                }}
                onClick={() => handleSelectStep(index)}
                key={index}
                selected={index === current}
              >
                {index > 0 && (
                  <RightOutlined
                    key={index}
                    style={{
                      fontSize: "10px",
                      fontWeight: "bold",
                      margin: "0 0.1rem",
                      color: "white",
                    }}
                  />
                )}
                {item.title}
              </StyledHeaderStep>
            ))}
        </>
      ) : (
        <StyledHeaderStep selected={false}>
          {items[current].title}
        </StyledHeaderStep>
      )}
    </StyledHeaderStepContainer>
  );
};

export default StepCustomHeader;
